import { getWarehouses } from '../../../services/stockJournal/warehouse';
import moment from 'moment';

export default {
    namespaced: true,
    state: {
        warehouses: [],
        lastUpdate: null
    },
    getters: {
        warehouses: state => state.warehouses,
        userWarehouses: (state, getters, rootState) => {
            let userWarehousesIDs = rootState.stockJournal.userWarehousesIDs;
            return state.warehouses.filter(each => userWarehousesIDs.includes(each.id))
        },
    },
    mutations: {
        setWarehouses: (state, payload) => state.warehouses = payload,
        setLastUpdate: (state) => state.lastUpdate = moment().format("YYYY-MM-DD HH:mm:ss")
    },
    actions: {
        fetchWarehouses:(context) => {
            return new Promise((resolve, reject) => {
                getWarehouses({ scope: "all" })
                    .then(response => {
                        context.commit("setWarehouses", response.data);
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        }
    }
}